import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Card from 'components/atoms/Cards/Card/Card';

const StyledNarration = styled(Card)`
  position: fixed;
  left: 50%;
  bottom: ${props => props.theme.layout('3sp')};
  transform: translateX(-50%);
  z-index: ${props => props.theme.property('zIndex.narration')};

  display: flex;
  flex-direction: column;
  width: clamp(0px, ${props => props.theme.layout(560)}, calc(100vw - (2 * ${props => props.theme.layout('2sp')})));
  overflow: hidden;

  .Narration {
    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: ${props => props.theme.spacing(1.25)} ${props => props.theme.spacing(1.25)} ${props => props.theme.spacing(1.25)} ${props => props.theme.spacing(3)};
      color: ${props => props.theme.property('palette.primary.contrastText')};
      background-color: ${props => props.theme.property('palette.primary.main')};
    }

    &-content {
      display: flex;
      flex-direction: column;
      gap: ${props => props.theme.layout('1sp')};
      padding: ${props => props.theme.spacing(2)};
    }

    &-speech {
      display: flex;
      align-items: flex-start;
      gap: ${props => props.theme.layout('2sp')};

      .Icon {
        font-size: ${props => props.theme.fontSize(36)};
      }
    }

    &-texts {
      display: flex;
      flex-direction: column;
      gap: ${props => props.theme.layout('1sp')};
    }

    &-aside {
      color: ${props => props.theme.property('palette.text.secondary')};
    }

    &-footer {
      display: flex;
      align-items: center;
      gap: ${props => props.theme.layout('3sp')};
    }

    &-progress {
      flex-grow: 1;
    }

    &-actions {
      display: flex;
      justify-content: flex-end;
      gap: ${props => props.theme.layout('1sp')};
      margin-left: auto;
    }
  }

  ${ComponentStyles}
`;

StyledNarration.propTypes = {
  theme: PropTypes.object
};

export default StyledNarration;
